<template>
  <LayoutHeader />
  <div>
    <LayoutLeftSide/>
    <router-view name="main"/>
  </div>
  <LayoutFooter/>
</template>

<script>
// @ is an alias to /src
import LayoutLeftSide from "@/components/LayoutLeftSide";
import LayoutFooter from "@/components/LayoutFooter";
import LayoutHeader from "@/components/LayoutHeader";

export default {
  name: 'HomeView',
  components: {
    LayoutHeader,
    LayoutFooter,
    LayoutLeftSide,
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
  display: flex;
}

</style>